import React from 'react';
import { View, Image, Text, StyleSheet, ViewStyle, TextStyle, Platform } from 'react-native';
import BrandWordmark from '../BrandWordmark';

const TAGLINE = 'Smart Financial Goals';

type Props = {
  /** light = on dark/navy backgrounds; dark = on light cards */
  variant?: 'light' | 'dark';
  logoSize?: number;
  style?: ViewStyle;
  /** Show tagline below the wordmark (native welcome screen) */
  showTagline?: boolean;
};

/** Centered app icon + GoalMint wordmark for auth screens. */
const AuthBrandHeader = ({
  variant = 'light',
  logoSize = 88,
  style,
  showTagline = false,
}: Props) => {
  const taglineColor =
    variant === 'light' ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,0.55)';

  return (
    <View style={[styles.container, style]}>
      <Image
        source={require('../../../assets/icon.png')}
        style={{ width: logoSize, height: logoSize, marginBottom: 16 }}
        resizeMode="contain"
      />
      <BrandWordmark variant={variant} size="lg" centered />
      {showTagline ? (
        <Text
          style={[styles.tagline, { color: taglineColor }, Platform.OS === 'web' && styles.taglineWeb]}
          accessibilityRole="text"
        >
          {TAGLINE}
        </Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    width: '100%',
  },
  tagline: {
    fontSize: 14,
    fontWeight: '500',
    marginTop: 6,
    textAlign: 'center',
    letterSpacing: 0.4,
  },
  taglineWeb: {
    userSelect: 'none',
  } as TextStyle,
});

export default AuthBrandHeader;
